/// REDUX ///
import { Dispatch } from "redux";
/// ACTION ///
import { Action } from "api/action_types/history";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/history";

export const closeAlert = () => {
  return (dispatch: Dispatch<Action>) => {

    dispatch({
      type: ActionType.CLOSE_ALERT
    });
  }
}
